import { FavoriteType } from "../enums/FavoriteType";
import { TagName } from "../model/Tags";
import { Condition, ValidationRuleVOActivity, ValidationRuleVOActivityUserGroup } from "../model/ValidationRuleModel";
import { QuickAccessWorkspace } from "./UserModel";

export interface WorkSpaceItem extends WorkSpaceItemCreate{
  validationRule?:ItemValidationRule;
  idVr?:string;
  id?: string;
  nameUser?:string;
}


export interface ShareFileTokenReturn{
  name?: string;
  extension?:string; 
  hasWatermark: boolean
}

export enum SearchType {
  ONLYMYDOCUMENTS = 0,
  FOLDER = 1,
  DEFAULT = 2
}

export interface WorkSpaceItemCreate extends ShareFileTokenReturn{
    idMongo?: string,
    fatherId?: string;
    itemType?: string;
    lastAccessDate?: string;
    lastWriteDate?: string;
    workspaceId?: string;
    size?:number;
    currentUserDraft?:string; 
    isRelease?:boolean; 
    revisions?:string[];
    description?:string;
    hash?:string;
    ownerId?:string;
    ownerName?:string;
    sensitivity?: number;
    archiving?:boolean;
    expired?:boolean;
    local?: string;
    shelf?: string;
    bookShelf?: string;
    position?: string;
    dateActionForwadOrBack: ActionForwadOrBack[];
    notificationEmail: boolean;
    currentUserReleaseName: string;
    currentUserDraftName: string;
    tagName:TagName[];
}

export interface BooleanVr{
  is:boolean;
}

export interface Archiving{
  idItem?:string;
  archiving?: boolean;

}

export interface Owner{
  idFolder?:string;
  idNewOwner?:string;
  NewName?:string;
  sensitivity?: number;
  idItem:string; 
  notificationEmail: boolean;
}

export interface WorkspacePendenci{
  workspaceId?: string;
  name?: string;
  filePendeci?: WorkSpaceUserName[];
}

export interface WorkSpaceItemRevision{
  id?:string;
  itemId?:string;
  itemName?:string;
  itemExtension?:string;
  currentDraft?:boolean; 
  currentRelease?:boolean; 
  draftBy?:string;
  draftDate?:string;
  releasedBy?:string;
  releasedDate?:string;
  itemDeleted?:boolean; 
  description?:string;
  isD4SignSigned?:boolean;
  enumerate?:number;
  shelf?: string;
  bookShelf?: string;
  position?: string;
}


export interface ItemFisicInformationsModel {
  Shelf?: string;
  BookShelf?: string;
  Position?: string;
}

export interface WorkSpaceItemTrakker{
  id?:string;
  itemName?:string;
  itemExtension?:string;
  workspaceId?:string;
  itemType?:number;
  enumerate?:number;
  trackerList?:WorkSpaceRevisionTrakker[];
}

export interface WorkSpaceRevisionTrakker{
  id?:string;
  description ?:string;
  enumerate?:number;
  trackerList?:TrakkerList[];
}

export interface RevisionTracker extends TrakkerList {
  idRevision: string;
  description: string;
  enumerate: number;
  dateTracker: string;
  nameItem: string;
}

export interface RevisionTrackerRequest {
  revisionSeletedId: string[],
  enumOrderRevisionTracker: number
}


export interface TrakkerList{
  id?:string;
  idItem?:string;
  idRevision?:string;
  idUser?:string;
  nameUser?:string;
  ipUser?:string;
  trackerDateTime?:string;
  dateCreateTracker?:string;
  typeIp?:string;
  origin?:string;
  message?:string;
  englishMessage?:string;
  enumerateReference?: number;
}

export interface trackerItemVO extends TrakkerList{
  nameItem?:string;
  message?:string;
  user?:string;
  ip?:string;
  dateCreateTracker?:string;
  revision?:string;
  itemExtension?:string;
  emailUser?: string;
  trackerType?: EnumTrackerType
  originWorkspace?: string;
  fatherId?: string;
}

enum EnumTrackerType { 
  createFile = 1,
  createFolder = 2,
  download = 3,
  pendency = 4,
  information = 5,
  deleteFile = 6
}

export interface ItemValidationRule
{
  currentVr?:string;
  actionId?:number;
  isTheUserResponsible:boolean;
  currentOperation?:string;
  backOperation?:string;
  preConditionsSaved: Condition[];
  forwardOperation?:string;
  pseudoValidation?: ValidationRuleVOActivity[];
  validationRuleDeleted?:boolean;
  timeDeadline?:string;
}

export interface ActionForwadOrBack{
  action?:number;
  nameResponsability?:string;
  dateUpdateForwadItem?:string;
  dateUpdateBackItem?:string;
  idAction?: number;
}


export interface WorkSpaceItemRecursive extends WorkSpaceItemCreate, WorkSpaceItem{
   children?:WorkSpaceItemCreate[];
   
}

export interface WorkSpaceUserName extends WorkSpaceItem{
  username?:string;
  d4SignStatus?:D4SignStatus;
  isD4SignSigned?:boolean;
  itemTemporality?:Temporality;
  existStorageArchive:boolean;
  expired?: boolean;
  unduDraftIsOpen: boolean;
  presentationSlug: string;
  accessSlug: string;
}

export interface Temporality{
  itemTemporality?:string;
  enumTemporality:number; 
}

export interface TemporalityVO extends Temporality{
  itemId?:string;
}

export interface D4SignStatus{
  uuid?:string;
}

export interface WorkspaceItemMove{
  idMongo?: string,
  idMongoNewFolder?:string,
  idNewWorkspace?:string
}

export interface WorkspaceItemMultiMove{
  idMongoNewFolder?:string,
  idItens?: string[],
}

export interface WorkspaceItemMultiMove{
  idMongoNewFolder?:string,
  idItens?: string[],
  idNewWorkspace?:string
}

export interface FolderInformation{
  workSpaceId:string,
  folderId?:string,
  fatherId?:string,
  folderName:string,
  pathList:IPath[],
  permissionType:number;
  isEditorCannotSeeRevision: boolean;
  folderOwnerInformation: IFolderOwnerInformation;
}

export interface IFolderOwnerInformation {
  id: string;
  name: string;
  picture: string;
  login: string;
}

export interface IPath {
  id: string 
  name: string 
}

export interface NewFolder{
  idFatherMongo?:string,
  workspaceIdMongo:string,
  name:string,
}

export interface RenameItem{
  idMongo:string,
  newName:string,
  newFileExtension:string|undefined
}

export interface SetFolow{
  idFatherMongo:string,
  isFolow:boolean,
}

export interface RevisionIsD4SignSigned{
  downloadCompleted:boolean,
  link:string,
}

export interface FileCreatedWebVO{
  itemId:string,
  warningMessage:string
}

export interface ItemDescription{
  itemId:string,
  itemDescription:string,
}

export interface FisicItemInformation {
  ItemId?: string,
  local?: string,
  bookShelf?: string,
  shelf?: string ,
  position?: string,
  additionalInformation?: string
}

export interface GetFlowInformationByItemVO {
  itemId?: string,
  itemName?: string,
  itemExtension?: string,
  isRelease?: boolean,
  username?: string,
  validationRule?:ItemValidationRule;
  draftDate?: string,
  releasedDate?: string,
  dateActionForwadOrBack?: ActionForwadOrBack[];
  activity?:ValidationRuleVOActivityUserGroup[];
  currentUserReleaseName: string;
  currentUserDraftName: string;
  wasDraft: boolean;
}

export interface BatchDownloadModel {
  IdItens: string[]
}

export interface BatchChangeStatusModel {
  idChangeStatus: string[]
}

export interface ReturnTemporalityVO
{
    itemId:string;
    itemTemporality:string;
    isToArchive:boolean;
    canArchive:boolean;
    nameItem:string;
    extensionItem:string;

}

export interface ReturnAutoArchiveVO
{
    itemId?:string;
    itemTemporality?:string;
    isToArchive?:boolean;
    nameItem?:string;
    extensionItem?:string;
}

export interface ReturnValidateDocumentVO
{
    itemId?:string;
    itemTemporality?:TemporalityVO;
    nameItem?:string;
    extensionItem?:string;
    existStorageArchive?: boolean;
}

export interface DeletedItem {
  itemId:string,
  name?:string,
  extencion?:string,
  workspaceId:string,
  workspaceName?: string
  folderId?:string,
  itemType?: number;
  whoExcludedId: string,
  whoExcludedLogin: string,
  dateDeletion: Date,
  createdDate: Date,
  fatherFolder?: string,
  ownerName: string,
  ownerLogin: string,
  isAdmOrg: boolean
  size: number
}

export interface ItemTemporality {
  itemId?:string,
  name?:string,
  extencion?:string,
  workspaceId?:string,
  folderId?:string,
  itemTemporality?:Temporality;
  description:string;
  isRelease:boolean;
  itemType?: string;
  validationRule:ItemValidationRule;
  archiving:boolean;
  expired:boolean;
  draft:boolean
  d4Signed?: boolean
}

export interface EnumAction{
  index: number;
  name: string;
}

export interface CopyFolderStructureVO{
  folderIdThatWillBeCopied: string,
  name: string,
  maintainPermissions: boolean,
}

export interface IBatchActionContent {
  differentFlowItems: IBatchItemReturn[];
  sameFLowItems: IBatchItemReturn[];
}

export interface IBatchItemReturn {
  id: string;
  name: string;
  messageError: string;
  extension: string;
}

export interface IBatchActionPayload {
  items: string[];
}

export interface ICreateFavoriteVO {
  favoriteName: string;
  organizationInternalName: string;
  favoriteType: number;
  extension: string;
  itemId: string;
  workspaceId?: string;
}

export interface IDeleteFavoriteVO {
  favoriteId: string;
  userId: string;
  organizationInternalName: string;
}

export interface IFavoriteModel {
  id: string;
  favoriteName: string;
  organizationInternalName: string;
  userEmail: string;
  userId: string;
  type: FavoriteType;
  extension: string;
  itemId: string;
  workspaceId?: string;
}

export interface IOrganizationCarrouselInfoVO {
  favoriteUserVO: IFavoriteModel[];
  quickAccessWorkspaceVO: QuickAccessWorkspace[];
}